import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import { Box, Typography } from "@mui/material";
import { TreeItem } from "@mui/x-tree-view/TreeItem";
import PropTypes from "prop-types";

import { identifiersData } from "@/data";
import { theme } from "@/theme";

const FoldersStructureTabTreeItem = ({ children, childrenNumber, itemId, name, rowId }) => {
    const { foldersStructure: foldersStructureId, treeItem: treeItemId } = identifiersData.ids;

    return (
        <TreeItem
            id={`${foldersStructureId}_${treeItemId}_${rowId}`}
            itemId={itemId}
            label={
                <Box
                    sx={{
                        alignItems: "center",
                        display: "flex",
                        ml: 1,
                        p: 0.5,
                        pr: 0,
                    }}
                >
                    <Box
                        component={FolderOpenIcon}
                        sx={{
                            color: "inherit",
                            mr: 1,
                        }}
                    />
                    <Box
                        sx={{
                            alignItems: "center",
                            display: "flex",
                            flexWrap: "nowrap",
                            gap: 2,
                            overflow: "auto",
                            "&::-webkit-scrollbar": { display: "none" },
                        }}
                    >
                        <Typography variant="caption">{name}</Typography>
                        {childrenNumber ? (
                            <Typography
                                variant="caption"
                                sx={{
                                    color: "white",
                                    bgcolor: theme.palette.primary.main,
                                    borderRadius: "50%",
                                    fontWeight: "bold",
                                    px: 1,
                                }}
                            >
                                {childrenNumber}
                            </Typography>
                        ) : null}
                    </Box>
                </Box>
            }
            sx={{
                "& .MuiTreeItem-content": {
                    borderBottomRightRadius: theme.spacing(2),
                    borderTopRightRadius: theme.spacing(2),
                },
                "& .MuiTreeItem-content[data-selected]": {
                    backgroundColor: theme.palette.grey[300],
                },
                color: theme.palette.grey[600],
            }}
        >
            {children}
        </TreeItem>
    );
};

export default FoldersStructureTabTreeItem;

FoldersStructureTabTreeItem.propTypes = {
    children: PropTypes.node,
    childrenNumber: PropTypes.number,
    itemId: PropTypes.string,
    name: PropTypes.string,
    rowId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
